
import { useState, useEffect } from 'react';
import { UAParser } from 'ua-parser-js';

interface DeviceFingerprint {
  fingerprint: string;
  deviceData: {
    browser: string;
    os: string;
    device: string;
    screenWidth: number;
    screenHeight: number;
    colorDepth: number;
    timezone: string;
    language: string;
  };
}

export function useDeviceFingerprint() {
  const [fingerprintData, setFingerprintData] = useState<DeviceFingerprint | null>(null);

  useEffect(() => {
    const generateFingerprint = () => {
      try {
        // Use UA-Parser-JS to get device info
        const parser = new UAParser();
        const browserResult = parser.getBrowser();
        const osResult = parser.getOS();
        const deviceResult = parser.getDevice();

        // Collect device data
        const deviceData = {
          browser: `${browserResult.name || 'Unknown'} ${browserResult.version || ''}`.trim(),
          os: `${osResult.name || 'Unknown'} ${osResult.version || ''}`.trim(),
          device: deviceResult.model ? `${deviceResult.vendor || ''} ${deviceResult.model || ''}`.trim() : 'Unknown',
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          colorDepth: window.screen.colorDepth,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: navigator.language
        };

        // Create fingerprint by hashing the device data
        const fingerprintString = JSON.stringify(deviceData);
        // Simple hash function
        let hash = 0;
        for (let i = 0; i < fingerprintString.length; i++) {
          const char = fingerprintString.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash; // Convert to 32bit integer
        }
        const fingerprint = Math.abs(hash).toString(16);

        setFingerprintData({
          fingerprint,
          deviceData
        });
      } catch (error) {
        console.error('Error generating device fingerprint:', error);
        setFingerprintData(null);
      }
    };

    generateFingerprint();
  }, []);

  return fingerprintData;
}
